export const i18n = (langIt, obj) => {
  return langIt ? obj.it : obj.en;
};
